<!--
 * @Author: zjw
 * @Date: 2021-05-18 10:46:59
 * @LastEditTime: 2022-09-19 10:52:55
 * @FilePath: \web-app\src\components\common\mainContent.vue
 * @Environment: Vue + Element
 * @Description: 基础组件
-->
<template>
  <!-- 布局容器的最外层容器 -->
  <el-container>
    <!-- 侧边栏 -->
	
    <Sildebar v-if="!(opened&&$route.path == '/homePage')"/>	
    <el-container >
			<!-- 头部区域 -->
			<el-header>
			  <Header />
			</el-header>
			<!-- 主内容区域 -->
			<el-main :class="{ homePage: $route.path == '/homePage' }">
			  <Content />
			</el-main>
    </el-container>
  </el-container>
</template>

<script>
import Sildebar from "./Sildebar";
import Header from "./Header";
import Content from "./Content";
import { mapState } from "vuex"
export default {
  name: "mainContent",
  components: {
    Sildebar,
    Header,
    Content,
  },
  data() {
    return {
      isHomePage: false,
    }
  },
  computed:{
	  ...mapState(['opened'])
  },
  watch: {
    "$route.path": {
      handler(value) {
        if (value == "/homePage") {
          this.isHomePage = true;
        } else {
          this.isHomePage = false;
        }
      },
      immediate: true,
    },
	"opened":{
		handler(value){
			
		},
		immediate: true,
	}
  },
};
</script>

<style scoped lang='scss'>
/* 侧边栏的高度 */
.el-container {
  height: 100%;
}

/* 头部的宽度 */
.main-container {
  width: 100%;
}

.el-header {
  padding: 0px;
  margin: 0px;
  height: 60px !important; //覆盖内联样式转换成rem
}
// 当屏幕宽度大于1928的时候默认为210px
@media screen and (min-width: 1920px) {
  .el-header {
    height: 60px !important; /*no*/
  }
}
.el-main {
  background-color: #f6f9fc;
  height: 100%;
  /* min-width: 1000px; */
}
.homePage {
  padding: 1px;
}
.screenFull{
	display: flex;
	flex: 1;
	flex-direction: column;
}
</style>